import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import useFirebase from "../../../../useFirebase";
import useLangTranslation from "../../../customHooks/languageProvider";
import { isEmpty } from "lodash";
import { setErrorInfo, setShowMessage } from "../../AxiosRtk/successMessage";
import { timeSupervision } from "../../AxiosRtk/DashBoard";
import useSubscription from "../../../customHooks/subscriptionProvider";
import { setTimeSupervision } from "../../AxiosRtk/SetRules";
import { colors } from "@mui/material";

const initialValueForDayTime = {
  monday: 0,
  tuesday: 0,
  wednesday: 0,
  thursday: 0,
  friday: 0,
  saturday: 0,
  sunday: 0,
};

const initialValueForDayToggleData = {
  monday: 0,
  tuesday: 0,
  wednesday: 0,
  thursday: 0,
  friday: 0,
  saturday: 0,
  sunday: 0,
};

const SetDailyLimitModal = ({
  showModal,
  closeModal,
  handleFilterSave,
  filterData,
  setFilterData,
  name,
  deviceId,
  postCollectionData,
  createCollectionData,
  addNewApp,
  appTimeAvailableData,
}) => {
  const dispatch = useDispatch();
  const { checkSubsciption } = useSubscription();
  const { user } = useSelector(({ auth }) => auth);
  const { getLangTranslation } = useLangTranslation();
  const { getCollectionData } = useFirebase();
  const [selectedTimeOption, setSelectedTimeOption] = useState("");
  const [isDeviceLocked, setIsDeviceLocked] = useState(false);
  const { selectedDeviceData, selectedKidId } = useSelector(
    ({ dashboard }) => dashboard
  );
  const { timesupervison, keystrokesmonitoring } = useSelector(
    ({ setRules }) => setRules?.setRulesData || {}
  );
  const [timeSupervisionData, setTimeSupervisionData] = useState(null);
  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const timeOptions = [
    {
      option: "4 hours",
      value: 240,
    },
    {
      option: "3 hours",
      value: 180,
    },
    {
      option: "2 hours",
      value: 120,
    },
    {
      option: "1 hour",
      value: 60,
    },
    {
      option: "45 minutes",
      value: 45,
    },
    {
      option: "30 minutes",

      value: 30,
    },
  ];

  useEffect(() => {
    if (selectedDeviceData && showModal) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData, showModal]);

  function timeSupervisionApi(toggleData = null) {
    let dailyLimit = {
      ...initialValueForDayTime,
    };

    const dailyToggleData = { ...initialValueForDayToggleData };

    const totalMin = parseInt(selectedTimeOption);

    dailyLimit["monday"] = totalMin;
    dailyLimit["tuesday"] = totalMin;
    dailyLimit["wednesday"] = totalMin;
    dailyLimit["thursday"] = totalMin;
    dailyLimit["friday"] = totalMin;
    dailyLimit["saturday"] = totalMin;
    dailyLimit["sunday"] = totalMin;
    dailyToggleData["monday"] = 1;
    dailyToggleData["tuesday"] = 1;
    dailyToggleData["wednesday"] = 1;
    dailyToggleData["thursday"] = 1;
    dailyToggleData["friday"] = 1;
    dailyToggleData["saturday"] = 1;
    dailyToggleData["sunday"] = 1;

    const dailyLimitDayFormattedDB = {};

    for (let day in dailyLimit) {
      dailyLimitDayFormattedDB[`${day[0]?.toUpperCase()}${day.slice(1)}`] =
        dailyLimit[day];
    }

    let tempDailyLimitSelectedDays = {};
    if (isEmpty(toggleData)) {
      for (let day in dailyToggleData) {
        tempDailyLimitSelectedDays[`${day[0]?.toUpperCase()}${day.slice(1)}`] =
          dailyToggleData[day];
      }
      // tempDailyLimitSelectedDays = { ...dailyToggleData }
    } else {
      for (let day in toggleData) {
        tempDailyLimitSelectedDays[`${day[0]?.toUpperCase()}${day.slice(1)}`] =
          toggleData[day];
      }
    }

    const payload = {
      kidId: selectedKidId,
      deviceId,
      DailyLimit: dailyLimitDayFormattedDB,
      dailyLimitSelectedDays: tempDailyLimitSelectedDays,
      IsWarnKidByAlertEnabled:
        setRulesData?.timesupervison?.isWarnKidByAlertEnabled,
      IsDeviceTimeSupervisionEnabled:
        setRulesData?.timesupervison?.isDeviceTimeSupervisionEnabled,
      IsBlockWebAndAppEnabled:
        setRulesData?.timesupervison?.isBlockWebAndAppEnabled,
      IsAllowAndMonitorParentsEnabled:
        setRulesData?.timesupervison?.isAllowAndMonitorParentsEnabled,
      dailyLimitSeekBarProgress: totalMin,
      AllowedApps: [],
      AllowedContacts: [],
    };

    let toggleDataCollectionPayload = {};
    if (!isEmpty(toggleData)) {
      toggleDataCollectionPayload = { ...toggleData };
    } else {
      for (const key in dailyToggleData) {
        toggleDataCollectionPayload[
          `${key[0]?.toLowerCase()}${key?.slice(1)}`
        ] = dailyToggleData[key];
      }
    }

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      dailyLimit,
      dailyLimitSelectedDays: toggleDataCollectionPayload,
      dailyLimitSeekBarProgress: totalMin,
      isBlockWebAndAppEnabled: isDeviceLocked ? 1 : 0,
      isAllowAndMonitorParentsEnabled: 0,
      isWarnKidByAlertEnabled: 0,
    };

    if (isDeviceLocked) {
      collectionPayload["timesupervison"] = {
        ...collectionPayload?.timesupervison,
        isDeviceTimeSupervisionEnabled: 1,
      };
    }

    if (setRulesData) {
      postCollectionData(deviceId, { timesupervison: collectionPayload });
    } else {
      createCollectionData(deviceId, { timesupervison: collectionPayload });
    }

    console.log(payload, collectionPayload);

    getCollectionData(deviceId);
    // setApiHit(true);

    timeSupervision(payload)
      .then((response) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: response?.data?.message,
            message: response?.data?.message,
          })
        );
      })
      .catch((err) => {
        console.log(
          "time supervision catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        // setApiHit(false);
      });
  }

  function handleAddLimitBtn() {
    // console.log(deviceId)
    if (!checkSubsciption()) {
      return;
    }
    if (!deviceId) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Device not selected",
          defaultTitle: "Device not selected",
        })
      );
      return;
    }

    timeSupervisionApi();
  }

  async function handleToggleChange() {
    const payload = {
      kidId: selectedKidId,
      deviceId: JSON.parse(selectedDeviceData)?.ID,
      is_load_default_settings: 0,
      AllowedApps: [],
      AllowedContacts: [],
      DailyLimit: {},
      Schedule: [],
      dailyLimitSeekBarProgress: 0,
    };

    let collectionPayload = null;

    // collectionPayload = {
    //   timesupervison: {
    //     ...timeSupervisionData,
    //     isBlockWebAndAppEnabled: isDeviceLocked ? 1 : 0,
    //     isAllowAndMonitorParentsEnabled: 0,
    //     isWarnKidByAlertEnabled: 0,
    //   },
    // };

    payload["IsBlockWebAndAppEnabled"] = isDeviceLocked ? 1 : 0;
    payload["IsWarnKidByAlertEnabled"] = 0;
    payload["IsAllowAndMonitorParentsEnabled"] = 0;

    if (isDeviceLocked) {
      // collectionPayload["timesupervison"] = {
      //   ...collectionPayload?.timesupervison,
      //   isDeviceTimeSupervisionEnabled: 1,
      // };
      payload["isDeviceTimeSupervisionEnabled"] = 1;
    }

    // callFirebase(collectionPayload);

    settingSetRulesDataIntoSqlDb(payload);

    console.log(collectionPayload, payload);
  }

  useEffect(() => {
    if (setRulesData?.timesupervison) {
      setTimeSupervisionData(setRulesData?.timesupervison ?? 0);
      // console.log("setRulesData?.timesupervison?.isDeviceTimeSupervisionEnabled ==>>", setRulesData?.timesupervison?.isDeviceTimeSupervisionEnabled)
      setIsDeviceLocked(
        setRulesData?.timesupervison?.isBlockWebAndAppEnabled == 1 ?? true
      );
    } else {
      setTimeSupervisionData(null);
      setIsDeviceLocked(false);
    }
  }, [setRulesData]);

  function callFirebase(payload) {
    if (setRulesData) {
      postCollectionData(selectedDeviceData?.ID, payload);
    } else {
      createCollectionData(selectedDeviceData?.ID, payload);
    }
    getCollectionData(selectedDeviceData?.ID);

    setTimeout(() => {
      dispatch(
        setShowMessage({
          showMessage: true,
          message: "KEYSTROKE_STATUS_UPDATED",
          defaultMessage: "Changes successfully updated",
        })
      );
    }, 1000);
  }

  function settingSetRulesDataIntoSqlDb(payload) {
    setTimeSupervision(payload)
      .then(() => {})
      .catch((err) => {
        console.log(
          "set time supervision catch error ==>>",
          err?.response?.data?.message
        );
      });
  }
  const handleSave = () => {
    handleAddLimitBtn();
    handleToggleChange();
    closeModal();
  };

  function getDay(item, day = false, time = false) {
    const daySelected = item?.DailyLimit;

    if (
      daySelected["Saturday"] > 0 &&
      daySelected["Sunday"] > 0 &&
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] === 0
    ) {
      if (day) {
        return "Weekends";
      } else if (time) {
        const totalMin = parseInt(daySelected["Saturday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Saturday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] > 0 &&
      daySelected["Tuesday"] > 0 &&
      daySelected["Wednesday"] > 0 &&
      daySelected["Thursday"] > 0 &&
      daySelected["Friday"] > 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Weekdays";
      } else if (time) {
        const totalMin = parseInt(daySelected["Monday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Monday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] > 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] === 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Monday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Monday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Monday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] > 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] === 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Tuesday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Tuesday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Tuesday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] > 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] === 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Wednesday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Wednesday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Wednesday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] > 0 &&
      daySelected["Friday"] === 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Thursday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Thursday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Thursday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] > 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Friday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Friday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Friday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] === 0 &&
      daySelected["Saturday"] > 0 &&
      daySelected["Sunday"] === 0
    ) {
      if (day) {
        return "Saturday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Saturday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Saturday"]);
        return totalMin;
      }
    } else if (
      daySelected["Monday"] === 0 &&
      daySelected["Tuesday"] === 0 &&
      daySelected["Wednesday"] === 0 &&
      daySelected["Thursday"] === 0 &&
      daySelected["Friday"] === 0 &&
      daySelected["Saturday"] === 0 &&
      daySelected["Sunday"] > 0
    ) {
      if (day) {
        return "Sunday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Sunday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Sunday"]);
        return totalMin;
      }
    } else {
      if (day) {
        return "Everyday";
      } else if (time) {
        const totalMin = parseInt(daySelected["Sunday"]);
        return minConvertToHr(totalMin);
      } else {
        const totalMin = parseInt(daySelected["Sunday"]);
        return totalMin;
      }
    }
  }

  function minConvertToHr(minutes) {
    if (minutes === 0) return `00 h 00 m`;
    else {
      const minInt = parseInt(minutes);
      const hr =
        Math.floor(minInt / 60) < 10
          ? `0${Math.floor(minInt / 60)}`
          : `${Math.floor(minInt / 60)}`;
      const min =
        Math.floor(minInt % 60) < 10
          ? `0${Math.floor(minInt % 60)}`
          : `${Math.floor(minInt % 60)}`;

      return `${hr}:${min}`;
    }
  }
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header className="border-0 pb-0">
            <div className=" border-0 pb-0 d-flex justify-content-between align-items-center w-100">
              <div>
                <h6 className="modal-title text-blue-900 mb-0">
                  {getLangTranslation(
                    "SET_DAILY_TIME_SET_THE_DAILY_TIME_LIMIT",
                    "Set the Daily Time Limit"
                  )}
                </h6>
                <p className="text-dark text-small mb-0">
                  {name} {getLangTranslation("SET_DAILY_TIME_CAN_SPEND_THIS_AMOUNT_OF_TIME", "can spend this amount of time at the device")}
                </p>
              </div>

              <button
                type="button"
                className={`btn-close ${lang?.isRTL === 1
                        ? ""
                        : "pe-4"
                        }`}
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
        </Modal.Header>

        <Modal.Body >
            <div className="border-bottom">
              {timeOptions?.map((item) => (
                <div
                  key={item?.option}
                  className="d-flex align-items-center gap-2 mb-3"
                >
                  <h6 className="text-blue-900 mb-0">{item?.option}</h6>
                  <input
                    className={`form-check-input ${lang?.isRTL === 1
                            ? " me-auto"
                            : " ms-auto"
                            }`}
                    type="radio"
                    value={item?.value}
                    onChange={() => {
                      setSelectedTimeOption(item?.value);
                    }}
                    checked={item?.value == selectedTimeOption}
                  />
                </div>
              ))}
            </div>
            <div className="form-check form-switch form-check-right py-5 border-bottom">
              <label
                className="form-check-label text-blue-900 text-small fw-semibold"
                htmlFor="LOCK_DEVICE"
              >
                {getLangTranslation(
                  "SET_DAILY_TIME_LOCK_THE_DEVICE_AFTER_THE_LIMIT",
                  "Lock the device after the limit"
                )}
              </label>
              <input
                className="form-check-input cursor-pointer"
                id="LOCK_DEVICE"
                type="checkbox"
                role="switch"
                name="LOCK_DEVICE"
                onChange={(e) => {
                  setIsDeviceLocked(!isDeviceLocked);
                }}
                checked={isDeviceLocked}
              />
            </div>
            <div className="pt-6 pb-3">
              <h5 className="text-blue-900 mb-3">{getLangTranslation("SET_DAILY_TIME_APP_TIME_LIMIT", "Apps time limit")}</h5>

              {appTimeAvailableData?.map((item, index) => {
                // console.log(item);
                return (
                  <div className="d-flex gap-3 justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-3 text-small" style={{color: '#03302B'}}>
                      <span className="icon-wrap icon-blue-50 border-0">
                        <img src={item?.image} width={24} alt="" />
                      </span>
                      {item?.app_name}
                    </div>
                    <h6 className="text-blue-900 mb-0 border py-1 px-2 rounded-pill">{getDay(item, false, true)}</h6>
                  </div>
                );
              })}
            </div>
            <button
              className="btn btn-outline-primary border-gray d-flex align-items-center justify-content-center gap-1 mb-6 w-100"
              type="button"
              onClick={() => {
                addNewApp();
              }}
            >
              <i className="icon-plus fs-4" />
              {getLangTranslation("SET_DAILY_TIME_ADD_A_NEW_LIMIT", "Add a New Limit")}
            </button>
            <div className="grid gap-3 pt-2">
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                onClick={() => {
                  closeModal();
                }}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CANCEL", "Cancel")}
                </span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                type="button"
                onClick={() => {
                  handleSave();
                }}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("SAVE", "Save")}
                </span>
              </button>
            </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SetDailyLimitModal;
